<template>
  <div
    class="c-collapsible-container c-collapsible-content"
    :aria-label="`${
      this.isOpen ? `Close ${this.content.title}` : `Show ${this.content.title}`
    }`"
  >
    <button
      type="button"
      class="c-button c-button--neutral"
      :aria-label="`${
        this.isOpen
          ? `Close ${this.content.title}`
          : `Show ${this.content.title}`
      }`"
      @click="isOpen = !isOpen"
      :aria-expanded="isOpen.toString()"
      :aria-controls="getId"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        :class="`${
          this.isOpen
            ? 'c-collapsible-content--open'
            : 'c-collapsible-content--closed'
        }`"
      >
        <use
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xlink:href="#chevron-right-circle"
        />
      </svg>
      {{ content.title }}
    </button>
    <div
      :id="getId"
      :class="contentClass"
      :aria-expanded="isOpen"
      :aria-hidden="!isOpen"
      role="region"
      :aria-label="content.title"
    >
      <div v-if="isOpen">
        <div v-if="showVideo" class="c-video-container__wrapper">
          <iframe
            :src="content.url"
            frameborder="0"
            allowfullscreen
            class="c-video-container__iframe"
          ></iframe>
        </div>
        <img
          v-if="showImage"
          class="c-collapsible-content__expandable-image"
          :src="content.url"
          :alt="content.alt"
          @click.self="expandImage = true"
        />
        <div v-if="showRichText" v-html="content.text"></div>
        <Modal
          :title="content.alt"
          :isVisible="expandImage"
          :closeButton="true"
          @close="closeExpandedImage"
        >
          <img
            class="c-collapsible-content__expandable-image--expanded"
            :src="content.url"
            :alt="content.alt"
          />
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
  import Modal from "./Modal.vue";

  export default {
    components: {
      Modal,
    },
    props: {
      id: {
        type: "string",
      },
      content: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        isOpen: false,
        expandImage: false,
      };
    },
    watch: {
      expandImage(isExpanded) {
        document.body.classList.toggle("modal-active", isExpanded);
      },
    },
    computed: {
      getId() {
        const titleId = this.content.title.replaceAll(" ", "-");
        return this.id || titleId;
      },
      contentClass() {
        return `c-collapsible-container__content ${
          this.isOpen
            ? "c-collapsible-container__content--open"
            : "c-collapsible-container__content--closed"
        }`;
      },
      showVideo() {
        return this.content.type == "video";
      },
      showImage() {
        return this.content.type == "image";
      },
      showRichText() {
        return this.content.type == "richText";
      },
    },
    methods: {
      closeExpandedImage() {
        this.expandImage = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/_contact-us-rap/_vue/CollapsibleContent.vue